@if (userAccountRole === 'CLIENT_ADMIN') {
  <app-display-counts-widget
    [widgetPanelCounts]="widgetPanelCounts"
    [title]="'QuickSourceBids'"
  ></app-display-counts-widget>
}

@if (userAccountRole === 'CLIENT_VENDOR_AND_SITES_MANAGER') {
  <app-title-content-widget [title]="'QuickSourceBids'">
    <ng-template #titleContentPanel>
      <div
        class="inner-panel cursor-select"
        (click)="navigateToQuickSourceBidsPage()"
      >
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-auto">
            <i class="lh-0 bi bi-clipboard-check fs-220"></i>
          </div>
        </div>
      </div>
    </ng-template>
  </app-title-content-widget>
}
